import { render, staticRenderFns } from "./foreignSupRegDetail.vue?vue&type=template&id=92c8c7dc&scoped=true&"
import script from "./foreignSupRegDetail.vue?vue&type=script&lang=js&"
export * from "./foreignSupRegDetail.vue?vue&type=script&lang=js&"
import style0 from "./foreignSupRegDetail.vue?vue&type=style&index=0&id=92c8c7dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c8c7dc",
  null
  
)

export default component.exports